import React from 'react'
import {

    STATE_NAMES,
    SPRING_CONFIG_NUMBERS
} from '../constants';
import { animated, useSpring } from 'react-spring';
import CountUp from 'react-countup'

function MapTool({ mapStatistic,email, setMapStatistic, cardData, regionHighlighted, isDistrictView, setModalityCheck, modalityCheck }) {




    const handleModalityChange = (event) => {
        const { value, checked } = event.target
        if (checked) {
            setModalityCheck(prev => [...prev, value])
        } else {
            setModalityCheck(prev => {
                return [...modalityCheck?.filter(data => data !== value)]
            })
        }
    }

    return (
        <div className='map-tool '>
            <div className='map-tool-div fadeInUp'>
                <div>
                    <h1>
                        {isDistrictView ? STATE_NAMES[regionHighlighted?.stateCode] : 'India'}
                    </h1>

                </div>
               {email!=='rajeshm@cancercentersofamerica.in' ?
                <div className='modality-check'>

                    <div>
                        <input type='checkbox' value='XRAY' checked={modalityCheck?.includes('XRAY')} placeholder='XRAY' onChange={handleModalityChange} />XRAY
                    </div>
                    <div>
                        <input type='checkbox' value='CT' checked={modalityCheck?.includes('CT')} onChange={handleModalityChange} />CT
                    </div>
                    <div>
                        <input type='checkbox' value='MRI' checked={modalityCheck?.includes('MRI')} onChange={handleModalityChange} />MRI
                    </div>
                    <div>
                        <input type='checkbox' value='NM' checked={modalityCheck?.includes('NM')} onChange={handleModalityChange} />NM
                    </div>
                </div>:<div></div>
}
                <div>
                    <div>Total </div>
                    <div> 
                    <CountUp
                                    start={0}
                                    end={cardData?.total}
                                    duration={0.5}
                                    delay={0}
                                />
                        </div>
                </div>

            </div>

            <div className='map-tool-detail'>
                <div className={`${mapStatistic === 'clients' ? 'prospect' : mapStatistic}`} >
                    <h1>{!isDistrictView ? STATE_NAMES[regionHighlighted?.stateCode] : regionHighlighted?.districtName ? regionHighlighted?.districtName : STATE_NAMES[regionHighlighted?.stateCode]}</h1>
                    <h1>
                        {/* <animated.div> */}
                        {/* {regionHighlighted?.value?.toLocaleString()} */}
                        {/* {total?.to((n)=>n)}
                    </animated.div> */}

                        <CountUp start={0} end={regionHighlighted?.value} duration={0.5} delay={0} />

                    </h1>
                    <div>{mapStatistic === 'clients' ? 'Prospects' : mapStatistic === 'onboard' ? 'Onboarded' : mapStatistic === 'active' ? 'Active' : 'Inactive'}</div>
                </div>


                <div className='toolti-map' >

                    <svg aria-hidden="true" focusable="false"
                        onClick={() => setMapStatistic('clients')}
                        className={`prospect-tool ${mapStatistic === 'clients' && 'prospect-click'}`}
                        role="img"><path d="M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"></path></svg>

                    <svg aria-hidden="true" focusable="false"
                        onClick={() => setMapStatistic('onboard')}
                        className={`onboard-tool ${mapStatistic === 'onboard' && 'onboard-click'}`}
                        role="img"><path d="M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"></path></svg>

                    <svg aria-hidden="true" focusable="false"
                        onClick={() => setMapStatistic('active')}
                        className={`active-tool ${mapStatistic === 'active' && 'active-click'}`}

                        role="img"><path d="M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"></path></svg>
                    <svg aria-hidden="true" focusable="false"
                        onClick={() => setMapStatistic('inactive')}
                        className={`inactive-tool ${mapStatistic === 'inactive' && 'inactive-click'}`}
                        role="img"><path d="M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"></path></svg>

                </div>

            </div>

        </div>
    )
}

export default MapTool
